// extracted by mini-css-extract-plugin
module.exports = {"root":"modal_root__1mZhI"};